import React from "react";
import { Helmet } from "react-helmet-async";
import { match as Match } from "react-router-dom";
import { injectIntl, IntlShape } from "react-intl";
import OperatorForm from "../form";
import PageSubheader from "../../../../components/PageSubheader";

interface Props {
  match: Match<{ id: string }>;
  intl: IntlShape;
}

const OperatorUpdate = (props: Props) => {
  const { intl } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: `page.operator.update.document.title` })}
        </title>
      </Helmet>

      <PageSubheader title="page.operator.details" />

      <OperatorForm {...props} />
    </>
  );
};

export default injectIntl(OperatorUpdate);
